[color=default] {
	--smoothly-color: var(--smoothly-default-color);
	--smoothly-color-contrast: var(--smoothly-default-contrast);
	--smoothly-color-shade: var(--smoothly-default-shade);
	--smoothly-color-tint: var(--smoothly-default-tint);
}

[color=primary] {
	--smoothly-color: var(--smoothly-primary-color);
	--smoothly-color-contrast: var(--smoothly-primary-contrast);
	--smoothly-color-shade: var(--smoothly-primary-shade);
	--smoothly-color-tint: var(--smoothly-primary-tint);
}

[color=secondary] {
	--smoothly-color: var(--smoothly-secondary-color);
	--smoothly-color-contrast: var(--smoothly-secondary-contrast);
	--smoothly-color-shade: var(--smoothly-secondary-shade);
	--smoothly-color-tint: var(--smoothly-secondary-tint);
}

[color=tertiary] {
	--smoothly-color: var(--smoothly-tertiary-color);
	--smoothly-color-contrast: var(--smoothly-tertiary-contrast);
	--smoothly-color-shade: var(--smoothly-tertiary-shade);
	--smoothly-color-tint: var(--smoothly-tertiary-tint);
}

[color=success] {
	--smoothly-color: var(--smoothly-success-color);
	--smoothly-color-contrast: var(--smoothly-success-contrast);
	--smoothly-color-shade: var(--smoothly-success-shade);
	--smoothly-color-tint: var(--smoothly-success-tint);
}

[color=warning] {
	--smoothly-color: var(--smoothly-warning-color);
	--smoothly-color-contrast: var(--smoothly-warning-contrast);
	--smoothly-color-shade: var(--smoothly-warning-shade);
	--smoothly-color-tint: var(--smoothly-warning-tint);
}

[color=danger] {
	--smoothly-color: var(--smoothly-danger-color);
	--smoothly-color-contrast: var(--smoothly-danger-contrast);
	--smoothly-color-shade: var(--smoothly-danger-shade);
	--smoothly-color-tint: var(--smoothly-danger-tint);
}

[color=light] {
	--smoothly-color: var(--smoothly-light-color);
	--smoothly-color-contrast: var(--smoothly-light-contrast);
	--smoothly-color-shade: var(--smoothly-light-shade);
	--smoothly-color-tint: var(--smoothly-light-tint);
}

[color=medium] {
	--smoothly-color: var(--smoothly-medium-color);
	--smoothly-color-contrast: var(--smoothly-medium-contrast);
	--smoothly-color-shade: var(--smoothly-medium-shade);
	--smoothly-color-tint: var(--smoothly-medium-tint);
}

[color=dark] {
	--smoothly-color: var(--smoothly-dark-color);
	--smoothly-color-contrast: var(--smoothly-dark-contrast);
	--smoothly-color-shade: var(--smoothly-dark-shade);
	--smoothly-color-tint: var(--smoothly-dark-tint);
}
